// extracted by mini-css-extract-plugin
export default {"dataCount":"totalDataCount_dataCount__omI1a","planCount":"totalDataCount_planCount__uKhCm","dataText":"totalDataCount_dataText__HTACr"};